/** @format */

import React, { Component } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

import { history } from './history';
import { AuthorizationCheckRouter } from './AuthorizationCheckRouter';
import AuthLayout from 'layouts/Auth.jsx';
import AdminLayout from 'layouts/Admin.jsx';
import OplTheme from '../assets/themes/OPL/OplTheme';

class App extends Component {
    componentDidMount() {
        if (process.env.REACT_APP_CHROME_DEBUG === 'true') {
            localStorage.debug = process.env.REACT_APP_DEBUG;
        }
    }

    componentWillUnmount() {
        if (process.env.REACT_APP_CHROME_DEBUG === 'true') {
            localStorage.removeItem('debug');
        }
    }

    render() {
        return (
            <OplTheme>
                <Router history={history}>
                    <Switch>
                        <Route exac path={process.env.REACT_APP_LOGIN_PAGE} component={AuthLayout} />
                        <AuthorizationCheckRouter path={process.env.REACT_APP_ROUTE_NAME} component={AdminLayout} />
                        <Redirect to={process.env.REACT_APP_LOGIN_PAGE} />
                    </Switch>
                </Router>
            </OplTheme>
        );
    }
}

export default App;
